import { VMoney } from "v-money";

export function parseToMoney (value) {
    if (!value) value = 0;
    if (typeof value == 'string' && value.includes('$')){
        return value;
    }else{
        return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP'}).format(value);
    }
}

export const configMoney = {
    decimal: ",",
    thousands: ".",
    prefix: "$ ",
    suffix: "",
    precision: 0,
    allowBlank: true,
}

export const Money = VMoney
